var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#"},domProps:{"textContent":_vm._s(_vm.$t('legal.links.privacyPreferences'))},on:{"click":function($event){$event.preventDefault();return _vm.openPreferences.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }